import * as fromDatatype from '../datatype-library/index';

export interface bl_del_shipment_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    sender_type: fromDatatype.VarcharDatatypeInterface;
    receiver_type: fromDatatype.VarcharDatatypeInterface;
    from_branch_guid: fromDatatype.GuidDataFieldInterface;
    to_branch_guid: fromDatatype.GuidDataFieldInterface;
    from_location_guid: fromDatatype.GuidDataFieldInterface;
    to_location_guid: fromDatatype.GuidDataFieldInterface;
    from_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
    to_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
    logistics_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    shipment_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    item_barcode: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    total_quantity: fromDatatype.NumericDatatypeInterface;
    quantity: fromDatatype.NumericDatatypeInterface;
    width: fromDatatype.NumericDatatypeInterface;
    height: fromDatatype.NumericDatatypeInterface;
    length: fromDatatype.NumericDatatypeInterface;
    cbm: fromDatatype.NumericDatatypeInterface;
    weight: fromDatatype.NumericDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_2: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_3: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_4: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_5: fromDatatype.VarcharDatatypeInterface;
    sender_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sender_customer_code: fromDatatype.VarcharDatatypeInterface;
    sender_supplier_code: fromDatatype.VarcharDatatypeInterface;
    sender_name: fromDatatype.VarcharDatatypeInterface;
    sender_email: fromDatatype.VarcharDatatypeInterface;
    sender_phone_no: fromDatatype.VarcharDatatypeInterface;
    sender_address_1: fromDatatype.VarcharDatatypeInterface;
    sender_address_2: fromDatatype.VarcharDatatypeInterface;
    sender_address_3: fromDatatype.VarcharDatatypeInterface;
    sender_address_4: fromDatatype.VarcharDatatypeInterface;
    sender_address_5: fromDatatype.VarcharDatatypeInterface;
    sender_city: fromDatatype.VarcharDatatypeInterface;
    sender_postcode: fromDatatype.VarcharDatatypeInterface;
    sender_state: fromDatatype.VarcharDatatypeInterface;
    sender_country: fromDatatype.VarcharDatatypeInterface;
    sender_pickup_from_datetime_from: fromDatatype.TimestampTzDatatypeInterface;
    sender_pickup_from_datetime_to: fromDatatype.TimestampTzDatatypeInterface;
    recipient_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_2: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_3: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_4: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_5: fromDatatype.VarcharDatatypeInterface;
    recipient_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    recipient_customer_code: fromDatatype.VarcharDatatypeInterface;
    recipient_name: fromDatatype.VarcharDatatypeInterface;
    recipient_email: fromDatatype.VarcharDatatypeInterface;
    recipient_phone_no: fromDatatype.VarcharDatatypeInterface;
    recipient_address_1: fromDatatype.VarcharDatatypeInterface;
    recipient_address_2: fromDatatype.VarcharDatatypeInterface;
    recipient_address_3: fromDatatype.VarcharDatatypeInterface;
    recipient_address_4: fromDatatype.VarcharDatatypeInterface;
    recipient_address_5: fromDatatype.VarcharDatatypeInterface;
    recipient_city: fromDatatype.VarcharDatatypeInterface;
    recipient_postcode: fromDatatype.VarcharDatatypeInterface;
    recipient_state: fromDatatype.VarcharDatatypeInterface;
    recipient_country: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    process_resolution: fromDatatype.VarcharDatatypeInterface;
    sender_process_status: fromDatatype.VarcharDatatypeInterface;
    sender_process_resolution: fromDatatype.VarcharDatatypeInterface;
    recipient_process_status: fromDatatype.VarcharDatatypeInterface;
    recipient_process_resolution: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    sequence: fromDatatype.IntegerDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    from_branch_code: fromDatatype.VarcharDatatypeInterface;
    to_branch_code: fromDatatype.VarcharDatatypeInterface;
    from_location_code: fromDatatype.VarcharDatatypeInterface;
    to_location_code: fromDatatype.VarcharDatatypeInterface;
    from_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
    to_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
    from_address_type: fromDatatype.VarcharDatatypeInterface;
    to_address_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_shipment_hdr_RowClass implements bl_del_shipment_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    sender_type: fromDatatype.VarcharDatatypeInterface;
    receiver_type: fromDatatype.VarcharDatatypeInterface;
    from_branch_guid: fromDatatype.GuidDataFieldInterface;
    to_branch_guid: fromDatatype.GuidDataFieldInterface;
    from_location_guid: fromDatatype.GuidDataFieldInterface;
    to_location_guid: fromDatatype.GuidDataFieldInterface;
    from_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
    to_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
    logistics_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    shipment_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    item_barcode: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    total_quantity: fromDatatype.NumericDatatypeInterface;
    quantity: fromDatatype.NumericDatatypeInterface;
    width: fromDatatype.NumericDatatypeInterface;
    height: fromDatatype.NumericDatatypeInterface;
    length: fromDatatype.NumericDatatypeInterface;
    cbm: fromDatatype.NumericDatatypeInterface;
    weight: fromDatatype.NumericDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_2: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_3: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_4: fromDatatype.VarcharDatatypeInterface;
    sender_ref_no_5: fromDatatype.VarcharDatatypeInterface;
    sender_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sender_customer_code: fromDatatype.VarcharDatatypeInterface;
    sender_supplier_code: fromDatatype.VarcharDatatypeInterface;
    sender_name: fromDatatype.VarcharDatatypeInterface;
    sender_email: fromDatatype.VarcharDatatypeInterface;
    sender_phone_no: fromDatatype.VarcharDatatypeInterface;
    sender_address_1: fromDatatype.VarcharDatatypeInterface;
    sender_address_2: fromDatatype.VarcharDatatypeInterface;
    sender_address_3: fromDatatype.VarcharDatatypeInterface;
    sender_address_4: fromDatatype.VarcharDatatypeInterface;
    sender_address_5: fromDatatype.VarcharDatatypeInterface;
    sender_city: fromDatatype.VarcharDatatypeInterface;
    sender_postcode: fromDatatype.VarcharDatatypeInterface;
    sender_state: fromDatatype.VarcharDatatypeInterface;
    sender_country: fromDatatype.VarcharDatatypeInterface;
    sender_pickup_from_datetime_from: fromDatatype.TimestampTzDatatypeInterface;
    sender_pickup_from_datetime_to: fromDatatype.TimestampTzDatatypeInterface;
    recipient_ref_no_1: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_2: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_3: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_4: fromDatatype.VarcharDatatypeInterface;
    recipient_ref_no_5: fromDatatype.VarcharDatatypeInterface;
    recipient_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    recipient_customer_code: fromDatatype.VarcharDatatypeInterface;
    recipient_name: fromDatatype.VarcharDatatypeInterface;
    recipient_email: fromDatatype.VarcharDatatypeInterface;
    recipient_phone_no: fromDatatype.VarcharDatatypeInterface;
    recipient_address_1: fromDatatype.VarcharDatatypeInterface;
    recipient_address_2: fromDatatype.VarcharDatatypeInterface;
    recipient_address_3: fromDatatype.VarcharDatatypeInterface;
    recipient_address_4: fromDatatype.VarcharDatatypeInterface;
    recipient_address_5: fromDatatype.VarcharDatatypeInterface;
    recipient_city: fromDatatype.VarcharDatatypeInterface;
    recipient_postcode: fromDatatype.VarcharDatatypeInterface;
    recipient_state: fromDatatype.VarcharDatatypeInterface;
    recipient_country: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    process_resolution: fromDatatype.VarcharDatatypeInterface;
    sender_process_status: fromDatatype.VarcharDatatypeInterface;
    sender_process_resolution: fromDatatype.VarcharDatatypeInterface;
    recipient_process_status: fromDatatype.VarcharDatatypeInterface;
    recipient_process_resolution: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    sequence: fromDatatype.IntegerDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    from_branch_code: fromDatatype.VarcharDatatypeInterface;
    to_branch_code: fromDatatype.VarcharDatatypeInterface;
    from_location_code: fromDatatype.VarcharDatatypeInterface;
    to_location_code: fromDatatype.VarcharDatatypeInterface;
    from_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
    to_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
    from_address_type: fromDatatype.VarcharDatatypeInterface;
    to_address_type: fromDatatype.VarcharDatatypeInterface;
}